import { notify as oxygenNotify, TYPE } from '@8x8/oxygen-toaster'

import cacheService from './cache'

const DURATION = 6000
const APPLICATION_THEME = 'application-theme'

let notifyWrapper = (title, type) => {
  if (type === TYPE.error) {
    return oxygenNotify({
      content: title,
      type: TYPE.error,
      duration: DURATION
    })
  }

  if (type === TYPE.info) {
    return oxygenNotify({
      content: title,
      type: TYPE.info,
      duration: DURATION
    })
  }

  return oxygenNotify({
    content: title,
    type: TYPE.success,
    duration: DURATION
  })
}

export const showErrorNotification = title => {
  notifyWrapper(title, TYPE.error)
}

export const showInlineNotification = title => {
  notifyWrapper(title, TYPE.success)
}

export const showInfoNotification = title => {
  notifyWrapper(title, TYPE.info)
}

export const setNotification = lib => {
  if (!lib) {
    return
  }

  const {
    notify,
    INLINE,
    INLINE_INFO,
    INLINE_ERROR,
    ERROR,
    INFO
  } = lib
  notifyWrapper = (title, type) => {
    if (type === TYPE.error) {
      return notify({
        title,
        type: INLINE,
        subType: ERROR || INLINE_ERROR
      })
    }

    if (type === TYPE.info) {
      return notify({
        title,
        type: INLINE,
        subType: INFO || INLINE_INFO
      })
    }

    return notify({
      type: INLINE,
      title
    })
  }
}

export const getApplicationTheme = defaultTheme => new Promise(resolve => {
  cacheService.cache.get(APPLICATION_THEME, data => {
    let theme = defaultTheme

    if (data && data[APPLICATION_THEME]) {
      theme = data[APPLICATION_THEME].value
    }

    resolve(theme)
  })
})

export const setApplicationTheme = value => {
  cacheService.cache.set({ [APPLICATION_THEME]: { value } })
}
